import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRemoveCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "remove-circle" }), /* @__PURE__ */ _jsx("path", { d: "M12,23.5A11.5,11.5,0,1,0,.5,12,11.513,11.513,0,0,0,12,23.5ZM7.05,8.465A1,1,0,1,1,8.464,7.051l3.359,3.359a.25.25,0,0,0,.353,0l3.359-3.359a1,1,0,1,1,1.414,1.414L13.59,11.824a.25.25,0,0,0,0,.353l3.359,3.359a1,1,0,1,1-1.414,1.414l-3.359-3.359a.25.25,0,0,0-.353,0L8.464,16.95A1,1,0,0,1,7.05,15.536l3.359-3.359a.25.25,0,0,0,0-.353Z" })]
});
export default SvgRemoveCircle;
